import { Grid, Typography } from '@mui/material';
import React from 'react';
import Authorize from '../images/header/header-logo.svg';

export const MaintenancePage = () => {

    return (
        <React.Fragment>
            <Grid container spacing={0}>
                <Grid item xs={12} display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} p={6} height={'100vh'}>
                    <img src={Authorize} alt="401_Authorize" width="800px" height="250px" />
                    <Typography variant='body1' color={'#0136a1'} fontSize={'21px'} textAlign={'center'} pt={3}>
                        Our website is temporarily unavailable due to ongoing maintenance.
                        <br />Our team is working diligently to resolve the issue and restore access as soon as possible.
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment >
    );
};